(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessController', InfectionPrimaryAccessController);

    InfectionPrimaryAccessController.$inject = ['$scope', '$state', 'InfectionPrimaryAccess', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InfectionPrimaryAccessController ($scope, $state, InfectionPrimaryAccess, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.infectionPrimaryAccesses = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InfectionPrimaryAccess.query(function(result) {
                  vm.infectionPrimaryAccesses = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.infectionPrimaryAccesses, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InfectionPrimaryAccess.query(function(result) {
                vm.infectionPrimaryAccesses = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
